import { IResortPathInfo } from 'api/resort/types';
import { Routes } from 'routes';

import { PlanYourTrip } from './Component';
import { OuterPlanYourTripPropsType } from './types';

interface IRegionPlanYourTripProps extends OuterPlanYourTripPropsType {
  resort: IResortPathInfo,
}

const PlanYourTripResortWrapper = ({
  resort,
  ...props
}: IRegionPlanYourTripProps) => {
  const redirectLodgingPath = Routes.resortTripPlanningLodging(resort);
  const redirectSkiRentalPath = Routes.resortSkiRentals(resort);
  const { title_short: title } = resort;
  console.log(props.hasSkiRental, resort, 'PlanYourTripResortWrapper');
  return (
    <PlanYourTrip
      {...props}
      contextKey="resort"
      title={title}
      redirectLodgingPath={redirectLodgingPath}
      redirectSkiRentalPath={redirectSkiRentalPath}
    />
  );
};

export default PlanYourTripResortWrapper;
